<template>
	
	<BarArrowButton :flex="true" :large="true" class="linkAccounts " title="Spending Analysis" href="/#/aiop?add=true" :bgImage="require('@/assets/bg/marbles.png')">
		<div class="barArrowButtonSlotContent">
			<a :href="'/#/aiop?add=true'">
			<p class="small">Link your bank account to get started.</p>
			</a>
		</div>
	</BarArrowButton>
	
</template>

<script>
import BarArrowButton from './BarArrowButton.vue';

export default {
	name: "LinkAccountsShoutPanel",
	props: [],
	components: {
		BarArrowButton
	},
	data() {
		return{
			something: null
		}
	},
	methods: {
		onLoad() {
		}
	},
	mounted: function() { this.onLoad(); }
}
</script>

<style scoped>

.barArrowButtonSlotContent {
	padding: 20px;
	padding-top: 12px;
	padding-bottom: 5px;
	p {
		margin-top: -5px;
		font-size: 13px;
	}
}


</style>